import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { OrganizationStaffRoleType } from '@/shared/api/protocol-ts/model/dto_organization_staff_pb';

import { i18n } from '@/entities/organization';

export const usePermissionOptions = () => {
  const { formatMessage } = useIntl();

  return useMemo(
    () => [
      {
        label: formatMessage(
          i18n.permissionOwners[
            OrganizationStaffRoleType.OrganizationStaffRoleType_ClinicalAccess
          ],
        ),
        value:
          OrganizationStaffRoleType.OrganizationStaffRoleType_ClinicalAccess,
        comment: formatMessage(
          i18n.permissionOwnersComments[
            OrganizationStaffRoleType.OrganizationStaffRoleType_ClinicalAccess
          ],
        ),
      },
      {
        label: formatMessage(
          i18n.permissionOwners[
            OrganizationStaffRoleType
              .OrganizationStaffRoleType_LimitedClinicalAccess
          ],
        ),
        value:
          OrganizationStaffRoleType.OrganizationStaffRoleType_LimitedClinicalAccess,
        comment: formatMessage(
          i18n.permissionOwnersComments[
            OrganizationStaffRoleType
              .OrganizationStaffRoleType_LimitedClinicalAccess
          ],
        ),
      },
      {
        label: formatMessage(
          i18n.permissionOwners[
            OrganizationStaffRoleType
              .OrganizationStaffRoleType_NonClinicalMember
          ],
        ),
        value:
          OrganizationStaffRoleType.OrganizationStaffRoleType_NonClinicalMember,
        comment: formatMessage(
          i18n.permissionOwnersComments[
            OrganizationStaffRoleType
              .OrganizationStaffRoleType_NonClinicalMember
          ],
        ),
      },
    ],
    [formatMessage],
  );
};
